import { render, staticRenderFns } from "./DeliveryDetailLogs.vue?vue&type=template&id=22a1e4ac&scoped=true&"
import script from "./DeliveryDetailLogs.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailLogs.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailLogs.vue?vue&type=style&index=0&id=22a1e4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1e4ac",
  null
  
)

export default component.exports